import {
  __name
} from "./chunk-2IB33T4A.js";

// src/roles.ts
var Categorias = {
  0: "P\xFAblico",
  1: "Administrador",
  2: "Suporte",
  3: "Cliente",
  4: "Supervisor",
  5: "Funcion\xE1rio",
  6: "Avalia\xE7\xE3o",
  7: "Representante"
};
var CategoriaEnum = /* @__PURE__ */ (function(CategoriaEnum2) {
  CategoriaEnum2[CategoriaEnum2["Administrador"] = 1] = "Administrador";
  CategoriaEnum2[CategoriaEnum2["Suporte"] = 2] = "Suporte";
  CategoriaEnum2[CategoriaEnum2["Cliente"] = 3] = "Cliente";
  CategoriaEnum2[CategoriaEnum2["Supervisor"] = 4] = "Supervisor";
  CategoriaEnum2[CategoriaEnum2["Funcionario"] = 5] = "Funcionario";
  CategoriaEnum2[CategoriaEnum2["Avaliacao"] = 6] = "Avaliacao";
  CategoriaEnum2[CategoriaEnum2["Representante"] = 7] = "Representante";
  CategoriaEnum2[CategoriaEnum2["Publico"] = 0] = "Publico";
  return CategoriaEnum2;
})({});
var rankingCategorias = [
  1,
  2,
  7,
  3,
  6,
  4,
  5,
  0
];
function getRoleByCategoria(categoria) {
  return Categorias[categoria];
}
__name(getRoleByCategoria, "getRoleByCategoria");

export {
  Categorias,
  CategoriaEnum,
  rankingCategorias,
  getRoleByCategoria
};
//# sourceMappingURL=chunk-CBV3WTX2.js.map